import 'whatwg-fetch';

const Api = {
    call (data) {
        return this.fetchJson(this.getEndpointPath() + this.convertToString(data))
    },
    fetchJson (url) {
        return fetch(url, {credentials: "include"})
            .then((response) => {
                if (response.headers.get('Content-Type').indexOf('text/html') !== -1) {
                    return response.text();
                }
                return response.json();
            })
    },
    getEndpointPath () {
        const BASE_URI = window.base_uri;
        const MODULE_URL = 'modules/cofiscart';
        return BASE_URI + MODULE_URL + '/cofiscartajax.php';
    },
    convertToString (data) {
        let parameters = [];
        for (let key in data) {
            if (data.hasOwnProperty(key) === false) {
                continue;
            }
            parameters.push(key + '=' + data[key])
        }
        if (parameters.length > 0) {
            return '?' + parameters.join('&');
        }
        return '';
    }
};
export default Api;
